// shared-types/src/account/types.ts - Account entity types
import { AccountDomain } from '../accountDomain'
import { Seller } from '../seller'

/** Billing data for Retaila service invoices (tenant / legal entity). Stored as JSON on `account.billingProfile`. */
export interface AccountBillingProfile {
    legalName?: string | null
    /** Tax id (e.g. RUT in UY/PY). */
    taxId?: string | null
    address?: string | null
    billingContactEmail?: string | null
    /**
     * Whether VAT (IVA) is charged/invoiced on top of service amounts.
     * Service plan amounts in the system are always stored net (sin IVA); this flag is for documents and UI.
     */
    invoiceVat?: boolean | null
    /** VAT rate when `invoiceVat` is true (e.g. 22 for Uruguay). Percent 0–100. */
    vatPercent?: number | null
}

export interface Account {
    id: string
    name: string
    slug: string
    logoId?: string
    currency: string
    email: string
    timezone: string
    status: AccountStatus
    country: string
    themeConfig?: ThemeConfig
    privateKey?: string
    demo: boolean
    createdAt: Date
    updatedAt: Date
    deletedAt?: Date
    sellerId?: string
    seller?: Seller
    accountDomains?: AccountDomain[]
    billingProfile?: AccountBillingProfile | null
    /** Set when the backoffice onboarding wizard was finished successfully. */
    onboardingWizardCompletedAt?: Date | null
    /** Set when the merchant chose to skip the onboarding wizard. */
    onboardingWizardSkippedAt?: Date | null
    /** True until the wizard is completed or skipped (backoffice gate). */
    needsOnboardingWizard?: boolean
}

export enum AccountStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    PENDING = 'PENDING',
    SUSPENDED = 'SUSPENDED',
}

export interface ThemeConfig {
    backgroundColor: string
    textColor: string
    primaryColor: string
    secondaryColor: string
}
